/** ----------------------------------------
    Node Modules
 ---------------------------------------- */

const YTPlayer = require('yt-player');

/** ----------------------------------------
     Tip Slide Template
 ---------------------------------------- */

const tip = data => {
    const html = `<div class="screen__slide">
            <div class="screen-tip__info">
                ${ data.label && `<span class="screen__label">${ data.label }</span>`}
                <h1 class="screen__title">${ data.title }</h1>
                <p class="screen__info">${ data.text }</p> 
            </div>
            <div class="screen__holder">
                <img class="screen__image" src="${ data.image }">
            </div>
        </div>`;

    return html;
};

/** ----------------------------------------
     Highlight Slide Template
 ---------------------------------------- */

const program = data => {
    const html = `
        
    `;

    return html;
};

/** ----------------------------------------
     Video Slide Template
 ---------------------------------------- */

const video = () => {
    const html = `
        <div class="screen-video">
            <div class="screen-video__holder"></div>
        </div>
    `;

    return html;
};

const setVideo = data => {
    const el = document.body.querySelector('.screen-video');

    return new YTPlayer(el, {
        annotations: false,
        autoplay: false,
        captions: false,
        controls: false,
        fullscreen: false,
        keyboard: false,
        info: false,
        related: false,
        modestBranding: true
    });
};

/** ----------------------------------------
     Ticket Row Template
 ---------------------------------------- */

 const ticket = data => {
    const html = `
        <div class="narrowcasting-ticket">
            <div class="screen__slide__ticket">
                <div class="list-item--tiny list-item__time">${ data.time }</div>
                <div class="list-item--large list-item__title">${ data.title }</div>
                <div class="list-item--small list-item__tickets list-item__tickets--${ data.tickets.replace(/ /g,"-").toLowerCase() }"> ${ data.tickets }</div>
                <div class="list-item--small list-item__location">${ data.location }</div>
            </div>
        </div>`;

    return html;
};

/** ----------------------------------------
     Poster Slide Template
 ---------------------------------------- */

 const poster = data => {
    if (data.text) {
        const html = `
            <div class="screen__slide">
                <div class="screen-poster__container">
                    <img src="${ data.image }">
                </div>
                <div class="screen-poster__info ${ data.theme }">
                    <h1 class="screen-poster__title">${ data.title }</h1>
                    <p>${ data.text }</p> 
                </div>
            </div>`;
        return html;
    } else {
        const html = `
            <div class="screen__slide">
                <div class="screen-poster__container">
                    <img src="${ data.image }">
                </div>
                <div class="screen-poster__info ${ data.theme } middle">
                    <h1 class="screen-poster__title">${ data.title }</h1>
                </div>
            </div>`;
        return html;
    }
};

/** ----------------------------------------
    Export Modules
 ---------------------------------------- */

module.exports = {
    tip,
    program,
    setVideo,
    ticket,
    video,
    poster,
};
